'use client';

import Fade from '@mui/material/Fade';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, MenuItem, Select } from '@/primitives';
import { useSocietySearchTabsModel } from './useSocietySearchTabsModel';
import { SocietySearchHeaderTabsLoading } from './SocietySearchHeaderTabsLoading';

/**
 * Search-type dropdown for the mobile AppBar (between logo and menu).
 */
export default function SocietySearchTabMobileSelect() {
  const { tabs, tabValue, handleTabChange, societyHeaderTabsLoading } =
    useSocietySearchTabsModel();

  const tabsTransitionKey = tabs.map((t) => t.value).join('|');

  if (societyHeaderTabsLoading) {
    return <SocietySearchHeaderTabsLoading variant="mobile" />;
  }

  return (
    <Fade key={tabsTransitionKey} in timeout={180}>
      <Box sx={{ width: '100%', minWidth: 0, display: 'flex' }}>
        <Select
          IconComponent={KeyboardArrowDownIcon}
          inputProps={{
            'data-dd-action-name': 'Tab: Search Type Select',
            'aria-label': 'Current module',
          }}
          sx={{
            width: '100%',
            minWidth: 0,
            borderRadius: '4px !important',
            height: '40px',
            backgroundColor: 'transparent',
            fontSize: '13px',
            fontWeight: 500,
            color: 'text.primary',
            '& .MuiOutlinedInput-notchedOutline': {
              border: '0.5px solid',
              borderColor: 'divider',
            },
            '& .MuiSelect-select': {
              py: '8px',
              pl: '14px',
              pr: '32px !important',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
            '& .MuiSelect-icon': {
              right: 10,
              fontSize: 18,
              color: 'text.secondary',
            },
          }}
          value={tabValue}
          onChange={(event) => {
            handleTabChange(event.target.value as string);
          }}
        >
          {tabs.map((tab) => (
            <MenuItem
              key={tab.value}
              value={tab.value}
              data-dd-action-name={`Tab: ${tab.label}`}
              onClick={
                // onChange does not fire when re-selecting the already-active tab
                // (e.g. tapping "Animal Enquiry" while on an animal detail page to
                // return to the search list), so onClick handles that case only.
                tab.value === tabValue
                  ? () => handleTabChange(tab.value)
                  : undefined
              }
            >
              {tab.label}
              {tab.icon != null && (
                <LockOutlinedIcon sx={{ fontSize: 16, ml: 0.5 }} />
              )}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Fade>
  );
}
